/**
 *
 * /Unsubscribe
 *
 */

import React, { useState, useEffect, memo } from 'react'

// NPM Libraries
import axios from 'axios'
import { useParams } from 'react-router-dom'

// Components
import Spinner from 'components/Spinner'
import UnsubscribeUser from 'components/Unsubscribe/UnsubscribeUser'
import UnsubscribeContact from 'components/Unsubscribe/UnsubscribeContact'

function Unsubscribe() {
	const { email_id } = useParams()
	const [contact_data, setContactData] = useState()
	const [user_data, setUserData] = useState()
	const [error, setError] = useState()

	useEffect(() => {
		if (email_id) {
			axios({
				method: 'GET',
				url: `${process.env.API_URL}/api/v1/emails/settings/${email_id}`,
			})
				.then((response) => {
					if (response.data.recipient_class === 'Contact') {
						setContactData(response.data)
					}
					if (response.data.recipient_class === 'User') {
						setUserData(response.data)
					} else {
						setError('recipient not found')
					}
				})
				.catch((e) => {
					setError(e)

					throw e
				})
		}
	}, [email_id])

	if (contact_data) return <UnsubscribeContact {...contact_data} email_id={email_id} />
	if (user_data) return <UnsubscribeUser {...user_data} email_id={email_id} />
	if (error)
		return <div className="m-4">Email recipient was not found. Please try a link from a different email.</div>
	return (
		<div className="m-5">
			<Spinner />
		</div>
	)
}

Unsubscribe.propTypes = {}

export default memo(Unsubscribe)
